import React from 'react'
import classNames from 'classnames'
import { Button } from './Buttons'
import './HaircareType.scss'

const types = [
  'ツヤのあるサラサラ髪', //0 つやつや ＆ さらさら
  'みずみずしく潤う髪', //1 つやつや ＆ しっとり
  '潤うサラサラヘア', //2 さらさら ＆ しっとり
  'ピュアなツヤ髪', //3 つやつや ＆ まとまり
  'まとまりのよい素直な髪', //4 さらさら ＆ まとまり
  'しっとりまとまりのある髪',  //5 しっとり ＆ まとまり
  'エアリーなツヤ髪',  //6 つやつや ＆ ふんわり
  'さらふわ髪',  //7 さらさら ＆ ふんわり
  'ふんわりとなめらかな髪',  //8 しっとり ＆ ふんわり
  '軽やかにまとまる髪', //9 まとまり ＆ ふんわり
  'ハリコシがあるツヤ髪', //10 つやつや ＆ ハリコシ
  'ハリコシのあるサラサラ髪', //11 さらさら ＆ ハリコシ
  'しなやかな髪', //12 しっとり ＆ ハリコシ
  'ハリコシがあってまとまる髪', //13 まとまり ＆ ハリコシ
  'ふんわりハリコシがある髪', //14 ふんわり ＆ ハリコシ
  // 単一
  '輝くようなツヤ髪', // つやつや
  '指通りのよいサラサラな髪', // さらさら
  'しっとり潤う髪', // しっとり
  'まとまりのある髪', // まとまり
  'エアリー感がある髪', // ふんわり
  'ハリコシのある髪', // ハリ・コシ
]
const { fileTemplateUrl } = window.JMO;


function findAllIndex(d) {
  return d.reduce((a, c, i) => {
    if(c !== false) {
      a.push(i)
    }
    return a
  }, [])
}


class HaircareType extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeIndex: 1,
    }
  }
  handleClose(e) {
    this.props.onClickClose()
  }
  calcTypeMatrix() {
    const cond = findAllIndex(this.props.cond.finish)
    let matindex = 0
    if (cond.length >= 2) {
      const n = 6
      const div = (cond[1] % n) - 1
      const r = cond[0] % n
      matindex = ((div) * (div + 1)) * 0.5 + r
    } else {
      matindex = cond[0] + 15
    }
    return types[matindex]

  }
  matchedItem() {
    return this.props.data.children.filter(d => d.matched)
  }
  getDamageLevel() {
    return this.props.cond.damage.filter(d => d === true).length
  }
  getTypeLead() {
    return this.calcTypeMatrix()
  }
  clickFavoriteButton(item) {
    // const listId = null
    console.log(item)
    // var listItem = {
    //   epi: item.sku, // Unique variant ID of the item
    //   empi: item.sku, // Master Product Id
    //   du: item.permalink, // Product URL
    //   qty: 1, // quantity 
    //   // note: note, //optional
    //   // cprops: {} // Optional custom attributes
    // };
    // try {
    //   window.swat.addToList(listId, listItem, function(newListItem){
    //     console.log(`Added item to list list Id ${listId}`, newListItem);
    //   }, function(xhrObj) {
    //     // something went wrong
    //   });
    // } catch (error) {
    //   console.log(error)
      
    // }
    
  }
  renderItem(item, i) {
    let product_image_main = '';
    let product_image_icon = '';
    let metadata = '';
    if (fileTemplateUrl) {
      product_image_main = fileTemplateUrl.replace('FILENAME', `${item.sku}.png`);
      product_image_icon = fileTemplateUrl.replace('FILENAME', `icon_${item.fragrance.id}.svg`);
      metadata = fileTemplateUrl.replace('FILENAME', `icon_g_${item.fragrance.id}.svg`);
    }
    return (
      <>
        <figure className={classNames({'product-image': true,[`product-image--${item.category.id}`]: true})}>
          <img className='product-image__main' src={product_image_main} alt={item.name} />
          <span className='product-image__icon'><img src={product_image_icon} alt={item.fragrance.name} /></span>
        </figure>

        <h1 className="product__copy" dangerouslySetInnerHTML={{ __html: item.copy }}></h1>
        <div className="product__name">{item.name}</div>
        <div className="product__data" dangerouslySetInnerHTML={{ __html: item.product_data }}></div>
        
        <ul className='metadata'>
          <li className={classNames({ 'metadata__category': true, [`metadata__category--${item.category.id}`]: true })}>
            {item.category.name}
          </li>
          <li className={classNames({'metadata__fragrance': true,[`metadata__fragrance--${item.fragrance.id}`]: true})}>
            <span><img src={metadata} alt={item.fragrance.name} /></span>
            {item.fragrance.name}
          </li>
        </ul>

        <nav className='product__action'>
          <a href={item.permalink} target="_blank" rel="noopener noreferrer" className="product__permalink">詳しくみる</a>
          <button className="product__favorite" onClick={e => this.clickFavoriteButton(item)}></button>
        </nav>
      </>
    )
  }
  render() {
    return (
      <div className="haircaretype">

        <div className='haircaretype__body'>
          <header className="haircaretype-header">
            <figure className="haircaretype__damagelevel damagelevel" data-level={this.getDamageLevel()}>
              <figcaption className='damagelevel__title'>あなたの髪のダメージレベル</figcaption>
              <div className='damagelevel__figure'>
                <span className="legend">Low</span>
                <div className='damagelevel__graph'>
                  <span className="teardrop"><img src="https://cdn.shopify.com/s/files/1/0847/8883/8720/files/teardrop.svg?v=1710126032" alt="" /></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                </div>
                <span className="legend">High</span>
              </div>
            </figure>
            <h1 className="haircaretype-header__lead">あなたがなりたいのは<br className="-sp" />{this.getTypeLead()}</h1>
            <p className="haircaretype-header__length">おすすめの<em>{this.matchedItem().length}</em>アイテム</p>
          </header>

          <div className="haircaretype__list">
            {this.matchedItem().map((item, i) => {
              return (
                <div key={i} className="product">
                  {this.renderItem(item, i)}
                </div>
              )
            })}
          </div>


          <Button onClick={e => this.handleClose(e)} addClass="haircaretype__close" />
          <Button onClick={e => this.handleClose(e)} addClass="transparent haircaretype__back">
            戻る
          </Button>
        </div>


        {(() => {
          if (this.props.data.banner) {
            return (
              <div className='haircare-footer'>
                <a className="haircare-footer__banner" href={this.props.data.banner.url} target="_blank" rel="noopener noreferrer">
                  <picture>
                    <source type="image/jpeg" media="(max-width: 959px)" srcSet={this.props.data.banner.image.sp} />
                    <source type="image/jpeg" media="(min-width: 960px)" srcSet={this.props.data.banner.image.pc} />
                    <img src={this.props.data.banner.image.sp} />
                  </picture>
                </a>
              </div>
            );
          }
        })()}
      </div>
    )
  }
}

export default HaircareType
